<template>
  <div class="flex flex-wrap mt-11">
    <div class="basis-full mb-0.5 md:md-0 md:basis-1/12 flex-wrap ">
      {{ date }}
    </div>
    <div class="basis-full md:basis-11/12 md:border-l border-dotted pl-6 border-neutral-500" >
      <h2>
        <NuxtLink
          :to="'/news/entry/' + entryUri"
          class="uppercase text-darkRed hover:text-darkBlue"
        >
          {{ title }}
        </NuxtLink>
      </h2>
      <div v-if="image_name" class="max-w-[300px]">
      <nuxt-img
          @click="visibleRef=true"
          preload
          width="300"
          format="webp"
          rel="preload"
          :src="siteURL + '/storage/images/news/'+album_path + '/thumbnail_cache/'+ image_cached"
          class="w-full h-full object-cover"
          :alt="image_name"
      />
        <vue-easy-lightbox :visible="visibleRef" :imgs="imgs" :index="0" :maxZoom="0" :swipeTolerance="20" :zoomScale="0" loop :moveDisabled="true" @hide="visibleRef=false">
          <template v-slot:close-btn="{ close }">
            <button @click="visibleRef=false" class="text-white fixed grid right-0 mr-3 z-70">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 352 512"  width="16" height="32" x="0" y="0" class="fill-white">
                <path d="M242.72 256l100.07-100.07c12.28-12.28 12.28-32.19 0-44.48l-22.24-22.24c-12.28-12.28-32.19-12.28-44.48 0L176 189.28 75.93 89.21c-12.28-12.28-32.19-12.28-44.48 0L9.21 111.45c-12.28 12.28-12.28 32.19 0 44.48L109.28 256 9.21 356.07c-12.28 12.28-12.28 32.19 0 44.48l22.24 22.24c12.28 12.28 32.2 12.28 44.48 0L176 322.72l100.07 100.07c12.28 12.28 32.2 12.28 44.48 0l22.24-22.24c12.28-12.28 12.28-32.19 0-44.48L242.72 256z"/>
              </svg>
            </button>
          </template>
          <template v-slot:toolbar="{ toolbarMethods }">
          </template>
        </vue-easy-lightbox>
      </div>
      <span v-show="type !== 'headlines'" class="text-sm">
        <div>
          <span class="ql-snow">
            <span class="ql-editor" style="white-space: normal">
              <span class="mb-4" v-html="content"></span>
            </span>
          </span>
          <NuxtLink
            v-if="showContinueLink == true"
            :to="'/news/entry/' + entryUri"
            class="
              text-darkRed
              hover:text-darkBlue
              underline underline-offset-1
            "
            >continued
          </NuxtLink>
        </div>
      </span>
    </div>
    <div
      v-show="type !== 'headlines'"
      class="basis-full flex items-center mb-2 md:mb-0 pt-6 justify-end flex"
    >
      <span class="pr-1.5">Share</span>

        <div class="border rounded-full p-3 border-black cursor-pointer hover:opacity-75" v-on:click="shareOn('facebook')">
          <svg
            class="w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 320 512"
          >
            <path
              d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
            />
          </svg>
        </div>

      <span class="px-1.5">|</span>

        <div class="border rounded-full p-3 border-black cursor-pointer hover:opacity-75" v-on:click="shareOn('twitter')">
          <svg
            class="w-5 h-5"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 512 512"
          >
            <path
              d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
            />
          </svg>
        </div>
    </div>
  </div>
</template>

<script setup>

import {ref} from "vue";
import VueEasyLightbox from 'vue-easy-lightbox/dist/external-css/vue-easy-lightbox.esm.min.js'
import 'vue-easy-lightbox/external-css/vue-easy-lightbox.css'

const props = defineProps([
  "title",
  "content",
  "showContinueLink",
  "entryUri",
  "date",
  "type",
  "album_path",
  "image_cached",
  "image_name",
]);
import {useSiteWeb,useSiteURL} from "~/composables/state";

const siteWeb = useSiteWeb();
const siteURL = useSiteURL();
const visibleRef = ref(false);
const imgs = ref([]);
if(props.image_cached){
  imgs.value.push({
    src: siteURL.value + '/storage/images/news/'+props.album_path + '/cache/'+ props.image_cached,
  })
}
const shareOn = (type) => {
  const url = siteWeb.value+'/news/entry/' + props.entryUri;
  let params = `scrollbars=no,resizable=no,status=no,location=no,toolbar=no,menubar=no,
width=0,height=0,left=-500,top=-500`;
  if(type === 'facebook'){
    window.open(`https://www.facebook.com/sharer/sharer.php?u=${url}`, '_blank',params)
  }
  if(type === 'twitter') {
    window.open(`https://twitter.com/intent/tweet?url=${url}`, '_blank', params)
  }
}

</script>
